import { render, staticRenderFns } from "./successPay.vue?vue&type=template&id=973ca060&"
import script from "./successPay.vue?vue&type=script&lang=js&"
export * from "./successPay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports